import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import { ClaimValuationsView } from '../components/views'

function ClaimValuations() {
    return (
        <div className="claimValuations">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Sentinel Tools" title="Claim Valuations" />
                    <ClaimValuationsView />
                </Page>
            </MainView>
        </div>
    )
}

export default ClaimValuations
